import styled from 'styled-components';
import {Form} from 'formik';
import {dFlex, dInlineFlex, alignCenter, justifyCenter, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const form = styled(Form)`
    ${dFlexColumn} ;
    gap: var(--space-xl) ;
    overflow: auto;
    height:calc(100% - 212px);
    padding: var(--space-xl) var(--space-lg);
`;

export const headerEnd = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-md);
`;

export const kebab = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: var(--space-xs);
    ${dInlineFlex}
    ${alignCenter}
    ${justifyCenter}
    color: rgba(0, 0, 0, 0.6);
`;
